import React from 'react';
import clsx from 'clsx';
import countries from 'i18n-iso-countries';

import css from './CountryFlag.module.scss';

export type CountryFlagSize = 'XL' | 'L' | 'M' | 'S';

interface Props {
    countryCode: string;
    size?: CountryFlagSize;
    className?: string;
}

const CountryFlag: React.FC<Props> = ({ countryCode, size = 'M', className }) => {
    const isCountryCodeValid = countries.isValid(countryCode);
    const flagSource = isCountryCodeValid && countryCode ? `/flags/${countryCode.toLowerCase()}.png` : '';

    if (flagSource === '') return null;

    return (
        <img
            className={clsx(css.flag, size && css[`size-${size}`], className && className)}
            src={flagSource}
            alt={countryCode}
        />
    );
};

export default React.memo(CountryFlag);
